import styled from 'styled-components';

export const Title = styled.h6`
  color: #acacac;
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.div`
  margin-right: 20px;
`;
export const ButtonContinue = styled.div`
  margin-right: 20px;
  margin-top: 0px;
`;
export const StatusBarWrapper = styled.div`
  width: 100%;
  padding: 20px 0 20px 20px;
  background-color: #333333;
  position: sticky;
  bottom: 0;
  left: 0;
  opacity: 1;
  color: #ffffff;
  z-index: 1;
`;

export const DueMonthlyWrapper = styled.div`
  display: inline-block;
  padding: 0 20px 0 0;
  height: 75px;
  vertical-align: top;
`;

export const DueMonthlyText = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px 0 0;
`;

export const Amount = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
`;

export const DueNowWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px;
  height: 75px;
  border-left: solid 1px #acacac;
  vertical-align: top;
`;

export const DueNowText = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px 0 0;
`;

export const ButtonsWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em
  height: 75px;
  vertical-align: top;
`;
